import { action } from "@ember/object"
import Component from "@glimmer/component"
import type { GoogleClassroomClassSetting } from "@shared/models/card-stack"
import type { CanonicalTimeParams } from "cc-frontend/helpers/format-time"
import { find, isNil, padStart } from "lodash-es"
import styles from "./time-picker.module.css"

interface Signature {
  Args: {
    onChange: ({ hour, minute }) => void
    googleClassId: string
    classSetting: GoogleClassroomClassSetting | undefined
    selectedTime: { hour: number; minute: number } | null
  }
}

export default class GoogleClassroomTimePickerComponent extends Component<Signature> {
  readonly styles = styles

  /** returns an array of 24 hour time options for scheduled/due time dropdown */
  get timeOptions() {
    let minuteIntervals = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55]
    let timesArray: Array<CanonicalTimeParams> = []
    for (let i = 0; i < 24; i++) {
      for (let j = 0; j < 12; j++) {
        timesArray.push({
          hour: i,
          minute: minuteIntervals[j],
          id: `${i}:${padStart(minuteIntervals[j].toString(), 2, "0")}`,
        })
      }
    }

    // We add an option for the end of the day (the default dueAt)
    timesArray.push({
      hour: 23,
      minute: 59,
      id: `23:59`,
    })
    return timesArray
  }

  @action onChange(value: string) {
    let time = find(this.timeOptions, { id: value })
    if (isNil(time)) return
    let { hour, minute } = time
    this.args.onChange({ hour, minute })
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Planner::Menus::GoogleClassroom::TimePicker": typeof GoogleClassroomTimePickerComponent
  }
}
